"use strict";

CompanyUserRoleService.$inject = ['config', '$resource'];
function CompanyUserRoleService(config, $resource) {
  return $resource(config.apiBase + '/companies/:companyId/user-roles/:roleId' , {}, {
    "update": {
      method: 'PUT'
    },
    "queryTemplates":  {
      url: config.apiBase + '/companies/:companyId/templates',
      method: 'GET',
      isArray: true
    },
    "addMember": {
      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users',
      method: 'POST'
    },
    "queryUsers":  {
      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users',
      method: 'GET',
      isArray: true
    },
    "removeMember": {
      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users/:userId',
      method: 'DELETE'
    },
    "saveTextbox": {
      url: config.apiBase + '/companies/:companyId/user-roles/:roleId',
      method: 'POST',
      transformRequest:  function(data) {
        var fd = new FormData();
        angular.forEach(data, function(value, key) {
            fd.append(key, value);
        });
        return fd;
      },
      headers: {"Content-Type": undefined, enctype:'multipart/form-data'}
    },
    "copyUserRole": {
      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/copy',
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyUserRoleService', CompanyUserRoleService);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/CompanyUserRoleService.js
// module id = 17
// module chunks = 0